module.exports = {
  apiUrl: process.env.REACT_APP_API_URL ?? '',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  GA4_JULO: process.env.REACT_APP_GA4_ID_JULO ?? '',
  APP_ENV: process.env.REACT_APP_ENV_NAME ?? '',
};
